import { useEffect } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";

import { DEFAULT_THEME, type ThemeId } from "./themes";

interface ThemeState {
  themeId: ThemeId;
  setTheme: (id: ThemeId) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      themeId: DEFAULT_THEME,
      setTheme: (themeId) => set({ themeId }),
    }),
    { name: "oneshift-theme-v2" },
  ),
);

/**
 * Applies the active theme to <html> by setting `data-theme`. Call once
 * at the root of the app — it subscribes to the theme store so any
 * change reflects immediately. In production builds the theme is locked
 * to `forest` (the OneShift brand) regardless of persisted state.
 */
export function useApplyTheme() {
  const themeId = useThemeStore((s) => s.themeId);
  const effective: ThemeId = import.meta.env.PROD ? "forest" : themeId;

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", effective);
  }, [effective]);
}
